export default "__VITE_ASSET__368e4248__$_?component__"